<ng-template #signAuthDialogTemplate>
    <form class="se-auth-dialog-container se-flex se-expand" (ngSubmit)="closeModal(false)">
        <div class="se-flex se-vertical se-expand">
            <div
                class="se-dialog-header mat-elevation-z6"
                [class.se-dialog-header-error]="isOnError"
                [class.se-dialog-header-warning]="isOnWarning"
            >
                <h3 mat-dialog-title translate><span translate>{{ isOnWarning? 'Warning':'MultiSign'}}</span></h3>
            </div>

            <div class="se-sign-dialog-content" [class.se-sign-dialog-waiting]="isWaiting | async">
                <mat-tab-group
                               *ngIf="!isOnWarning"
                    [(selectedIndex)]="selectedTabIndex"
                    (selectedTabChange)="onSelectedTabIndexChange($event)"
                >
                    <mat-tab *ngFor="let tab of data; let i = index" [attr.data-index]="i" aria-label="Profile tab">
                        <ng-template mat-tab-label>
                            <mat-icon style="color: #e53935" *ngIf="errorMessages[i]">error</mat-icon>
                            <mat-icon style="color: #61a566" *ngIf="!errorMessages[i] && data[i].info.pin"
                                >done
                            </mat-icon>
                            <span style="margin-left: 3px">{{ tab.info.signerName }}</span>
                        </ng-template>

                        <div class="credentials">

                            <mat-form-field appearance="outline">
                                <mat-label>{{ "Signer" | translate }}</mat-label>
                                <input
                                    name="sign_username_{{ i }}"
                                    matInput
                                    [placeholder]="'Signer' | translate"
                                    [(ngModel)]="data[i].info.signerName"
                                    tabindex="-1"
                                    autocomplete="off"
                                    readonly
                                />
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>{{ "Pin" | translate }}</mat-label>
                                <input
                                    #pin
                                    name="sign_pin{{ i }}"
                                    [type]="showPin[i] ? 'text' : 'password'"
                                    matInput
                                    [placeholder]="'Pin' | translate"
                                    [(ngModel)]="data[i].info.pin"
                                    autocomplete="new-password"
                                    required
                                />
                                <button
                                    type="button"
                                    matSuffix
                                    mat-icon-button
                                    aria-label="Show"
                                    (click)="showPin[i] = !showPin[i]"
                                    tabindex="-1"
                                >
                                    <mat-icon>{{ showPin[i] ? "visibility_off" : "visibility" }}</mat-icon>
                                </button>
                                <button
                                    *ngIf="!!data[i].info.pin"
                                    type="button"
                                    matSuffix
                                    mat-icon-button
                                    aria-label="Clear"
                                    (click)="data[i].info.pin = ''"
                                    tabindex="-1"
                                >
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>

                            <mat-form-field appearance="outline" *ngIf="isOtpRequired()">
                                <mat-label>{{ "OTP" | translate }}</mat-label>
                                <input
                                    #otp
                                    name="otp_{{ i }}"
                                    [type]="showOtp[i] ? 'text' : 'password'"
                                    matInput
                                    [placeholder]="'OTP' | translate"
                                    [(ngModel)]="oneTimePwd[i]"
                                    autocomplete="new-password"
                                    [required]="isOtpRequired()"
                                />
                                <button
                                    type="button"
                                    matSuffix
                                    mat-icon-button
                                    aria-label="Show"
                                    (click)="showOtp[i] = !showOtp[i]"
                                    tabindex="-1"
                                >
                                    <mat-icon>{{ showOtp[i] ? "visibility_off" : "visibility" }}</mat-icon>
                                </button>
                                <button
                                    *ngIf="!!oneTimePwd[i]"
                                    type="button"
                                    matSuffix
                                    mat-icon-button
                                    aria-label="Clear"
                                    (click)="oneTimePwd[i] = ''"
                                    tabindex="-1"
                                >
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>

                            <p
                                *ngIf="errorMessages[i]"
                                style="color: #e53935; flex-grow: 1; font-size: 0.75em; margin: 0 10px"
                            >
                                {{ errorMessages[i] }}
                            </p>
                        </div>
                    </mat-tab>
                </mat-tab-group>

                <mat-form-field appearance="outline" *ngIf="isTimeoutRequired()">
                    <mat-select
                        #signtimeout
                        panelClass="se-mat-select-panel-class"
                        [disableOptionCentering]="true"
                        name="combo-timeout"
                        [placeholder]="timeoutMessage"
                        [(ngModel)]="timeout"
                    >
                        <ng-container>
                            <mat-option [value]="10">10 <span translate>Minutes</span></mat-option>
                            <mat-option [value]="20">20 <span translate>Minutes</span></mat-option>
                            <mat-option [value]="30">30 <span translate>Minutes</span></mat-option>
                            <mat-option [value]="60">60 <span translate>Minutes</span></mat-option>
                            <mat-option [value]="0"><span translate>AlwaysPwd</span></mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>


                <p *ngIf="errorMessage && isOnError" class="se-sign-dialog-error-message">{{ errorMessage }}</p>
                <p *ngIf="signTypeNotSupported" class="se-sign-dialog-warning-message">{{ warningMessage }}</p>
            </div>
            <div mat-dialog-actions class="se-sign-dialog-action-container">
                <button
                    mat-button
                    color="primary"
                    class="se-dialog-action-button"
                    type="button"
                    (click)="closeModal(true)"
                    translate
                >
                    <span translate>{{ isOnWarning? 'ok':'Cancel'}}</span>
                </button>

                <button
                    mat-button
                      *ngIf="!isOnWarning"
                    class="se-dialog-action-button"
                    style="font-size: 1em"
                    type="button"
                    color="primary"
                    [disabled]="!currentIsSet()"
                    (click)="handleConfirmClick()"
                >
                    <span  translate>{{ enableSignButton() ? confirmLabel : nextLabel }}</span>
                </button>

                <button type="submit" [disabled]="!enableSignButton()" style="display: none">hidden submit</button>
            </div>
        </div>
    </form>

    <div class="estensa-spinner" style="background-color: transparent !important" *ngIf="isWaiting | async">
        <mat-spinner diameter="64" color="accent"></mat-spinner>
    </div>
</ng-template>
